import { Component } from '@angular/core';
import { ToastService } from './toast.service';
import { fader, slideIn } from 'src/app/Core/animation';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations:[fader, slideIn]
})
export class ToastComponent {
  constructor(private taost: ToastService) {}

  get notificationList() {
    return this.taost.notificationList;
  }

  hide(id: number) {
    this.taost.hide(id);
  }
}
